import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7301Model } from '../kymw7301.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetReceiptCatalogResponse = {
  ReceiptCatalog: string;
};

/**
 * 受付期間取得サービス
 *
 * @export GetReceiptCatalogService
 * @class GetReceiptCatalogService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetReceiptCatalogService extends PlessJsonResponderSub<GetReceiptCatalogResponse> {
  private model: KYMW7301Model;
  public couponIssuePeriod: string;
  public startFlg: string;
  public validWeek: number;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetReceiptCatalogService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CouponIssuePeriod: this.couponIssuePeriod,
        StartFlg: this.startFlg,
        ValidWeek: this.validWeek,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetReceiptCatalogService
   */
  execute(model: KYMW7301Model, couponIssuePeriod: string, startFlg: string, validWeek: number, f?: () => void): void {
    this.model = model;
    this.couponIssuePeriod = couponIssuePeriod;
    this.startFlg = startFlg;
    this.validWeek = validWeek;
    this.calbak = f;
    this.send('getReceiptCatalog', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof GetReceiptCatalogService
   */
  success(data: GetReceiptCatalogResponse) {
    if (this.startFlg === "1") {
      this.model.couponReceiptCatalogStart = data.ReceiptCatalog;
    } else if (this.startFlg === "0") {
      this.model.couponReceiptCatalogEnd = data.ReceiptCatalog;
    }
    if (this.calbak) this.calbak();
  }
}
